import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getLabel from './../../../../utils/labels'
import styles from './composedMinimizedMail.module.scss';

class ComposedMail extends Component {

    getPreText = (replyMailOptions) => {
        if (replyMailOptions.preText) {
            return replyMailOptions.preText.map((para, key) => <div className={styles.pretext} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
        }
    }

    getGreetingText = (composeBody) => {
        return getLabel('label_greetings_initial') + this.getFirstNamesOfActors(composeBody) + ", "
    };

    getPostText = (replyMailOptions) => {
        if (replyMailOptions.postText) {
            return replyMailOptions.postText.map((para, key) => <div className={styles.thanks} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
        }
    };

    getToActors = (composeBody, returnArray = false) => {
        const { actors } = this.props;
        let { to, cc } = composeBody;
        let temp, actorArray = [];
        to = [...to, ...cc];

        if (to) {
            let actorDetails = to.map((toActor) => {
                temp = actors.clients.find(actor => actor.id === toActor) || actors.inActors.find(actor => actor.id === toActor)
                if (temp) {
                    actorArray.push(temp.first_name + ' ' + temp.last_name)
                } else {
                    return actorArray.push(toActor);
                }

                if (cc.includes(toActor)) {
                    return { type: 'cc', details: temp }
                } else {
                    return { type: 'to', details: temp }
                }
            })

            if (returnArray) {
                return actorDetails
            }

            return actorArray.join(", ");
        }
    }

    getFirstNamesOfActors = (composeBody) => {
        let array = this.getToActors(composeBody, true);
        let actorNames = []
        if (array.length >= 2) {
            return getLabel('label_all_text')
        } else {
            array.map(item => {
                if (item.details.is_group_email === 0) {
                    actorNames.push(item.details.first_name)
                } else {
                    actorNames.push(getLabel('label_all_text'))
                }
            })
            return actorNames.join(", ");
        }
    }

    getBody = (body, replyMailOptions) => {
        return body.map((item, index) => {
            const currentMessage = replyMailOptions.rol.find((message) => message.id === item.messageGroupId);

            if (currentMessage.type === "mcq") {
                return this.getMessageSelectedOption(item.optionId, currentMessage.options);
            } else {
                return this.getMultipleMessageOption(item.choosenOptions, currentMessage.options, item.id);
            }
        })

    }

    getMultipleMessageOption = (optionsToDisplay, optionsItems, id) => {
        const list = optionsToDisplay.map((itemId, key) => {
            const itemText = optionsItems.find((option) => option.id === itemId);
            // console.log("notFound", optionsToDisplay, optionsItems);
            return itemText.text;
        });
        return list.join('');
    }

    getMessageSelectedOption = (optionId, optionsItems) => {
        const itemText = optionsItems.find((option) => option.id === optionId);
        // console.log("notFound", optionsToDisplay, optionsItems);
        return itemText.text;
    }

    getFromActor = () => {
        const { from, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === from) || actors.inActors.find(actor => actor.id === from);
        if (actorDetails) {
            return actorDetails.first_name + ' ' + actorDetails.last_name
        }
        return from;
    }

    getSelfActor = () => {
        const { actors, selfActor } = this.props;
        return actors.inActors.find(actor => actor.id === selfActor)
    }

    render() {
        const { replyMailOptions, actionThread, currentTime } = this.props;
        const composeBody = actionThread && actionThread.find((action) => action.type === "compose");
        // console.log(composeBody);

        let displayTime = Math.floor((composeBody.actionTakenAt - currentTime) / 60);
        if (!(displayTime > 0)) {
            displayTime = 0;
        }

        let selfActor = this.getSelfActor();
        return (
            <div className={styles.container} onClick={() => this.props.onMailClick()}>
                <div className={styles['icon-container']}>
                    <img src={selfActor.gravatar} className={styles.image} />
                </div>
                <div className={styles['content']}>
                    <header className={styles['header']}>
                        <div className={styles["people-container"]} >
                            <div className={styles['from']} >
                                {`${selfActor.first_name} ${selfActor.last_name}`}
                            </div>
                        </div>

                        <div className={styles['action-list']}>
                            <div className={styles.timer}>
                                {
                                    displayTime > 0 ?
                                        <div>{("0" + displayTime).slice(-2)} {getLabel('label_time_received_at')}</div>
                                        :
                                        <div>{getLabel('label_just_now')}</div>
                                }
                            </div>
                        </div>
                    </header>
                    <div className={styles.body}>
                        <div className={styles['body-text']}>
                            {/* {this.getGreetingText(composeBody)} */}
                            {/* {this.getPreText(replyMailOptions)} */}
                            {this.getBody(composeBody.body, replyMailOptions)}
                            {/* {this.getPostText(replyMailOptions)} */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ComposedMail.propTypes = {}

ComposedMail.defaultProps = {};

export default ComposedMail;



// WEBPACK FOOTER //
// /src/components/mailThread/mail/composedMinimizedMail/ComposedMinimizedMail.js